// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2JO-B","right":"Footer_right__bVtCr","buttons":"Footer_buttons__TWoQM"};